<template>
  <!-- employee -->
  <div v-if="isShowCondition('employee')" class="condition-form-item">
    <el-divider />

    <p class="input-label">制单人：</p>
    <select-people
      :onlySelectEmployee="true"
      ref="employee"
      :defaultVal="defaultVal"
      v-if="widgetStatus"
    />
  </div>

  <!-- department -->
  <div v-else-if="isShowCondition('department')" class="condition-form-item">
    <el-divider />

    <p class="input-label">部门：</p>
    <select-people
      :onlySelectDepartment="true"
      ref="department"
      :defaultVal="defaultVal"
      v-if="widgetStatus"
    />
    <el-checkbox v-model="includeChildDepartments">包含子部门</el-checkbox>
  </div>

  <!-- number -->
  <process-number v-else-if="isShowCondition('number')" ref="number" :config="config" />

  <!-- select -->
  <process-select v-else-if="isShowCondition('select')" ref="select" :config="config" />

  <process-multi-select
    ref="multiSelect"
    :config="config"
    v-else-if="isShowCondition('multiSelect')"
  />

  <!-- chargeTypes -->
  <charge-types v-else-if="isShowCondition('costTypes')" ref="chargeTypes" />

  <!-- project -->
  <div v-else-if="isShowCondition('project')" class="charge-item-project condition-form-item">
    <el-divider />

    <p class="input-label">项目：</p>
    <select-project ref="project" :defaultSelected="defaultParject" />

    <el-checkbox v-model="includeChildProject">包含子项目</el-checkbox>
  </div>

  <div v-else />
</template>

<script>
import ProcessNumber from "./components/Number";
import ProcessSelect from "./components/Select";
import ProcessMultiSelect from "./components/MultiSelect";
import ChargeTypes from "./components/ChargeTypes";
import SelectProject from "@/components/SelectProject/SelectByDialog";

export default {
  components: {
    ProcessNumber,
    ProcessSelect,
    ProcessMultiSelect,
    ChargeTypes,
    SelectProject
  },

  props: {
    /**
     * config: {
     *  code: "",
     *  name: "",
     *  type: "",
     *  valueFrom: "",
     *  selectValue: [
     *    { id: "", name: "" }
     *  ],
     *  api: ""
     * }
     */
    config: {
      type: Object
    },

    currentEditNode: {
      type: Object
    }
  },

  data() {
    return {
      defaultVal: [],
      defaultParject: [],
      widgetStatus: true,
      includeChildDepartments: false,
      includeChildProject: false
    };
  },

  methods: {
    getDocumentation() {
      return this.getConditionOperationConfig(
        this.config.type
      ).getDocumentation();
    },

    validateConditon() {
      if (this.config.type === "department") {
        return this.$refs["department"].selectedDepartments.length
          ? true
          : `${this.config.name}：请至少选择一个部门!`;
      } else if (this.config.type === "employee") {
        return this.$refs["employee"].selectedEmployees.length
          ? true
          : `${this.config.name}：请至少选择一个人员!`;
      } else if (this.config.type === "project") {
        return this.$refs["project"].selectedProject.length
          ? true
          : `${this.config.name}：请至少选择一个项目!`;
      } else if (this.config.type === "costTypes") {
        return this.$refs["chargeTypes"].chargeForm[0].length
          ? true
          : `${this.config.name}：请至少选择一个费用明细类型!`;
      } else if(this.config.type === "number") {
        return this.$refs["number"].validate
          ? true : `${this.config.name}：请填写正确的表达式!`
      }
    },

    getConditionExpression() {
      return this.getConditionOperationConfig(
        this.config.type
      ).getConditionExpression();
    },

    setConditionValue(data) {
      this.getConditionOperationConfig(this.config.type).setConditionValue(
        data
      );
    },

    isShowCondition(type) {
      return this.config.type === type;
    },

    // select
    getSelectDocumentation() {
      var selectedObj = this.$refs["select"].selectedObj;
      if (!selectedObj) {
        return {
          value: {}
        };
      }
      return {
        value: {
          name: selectedObj.name,
          id: selectedObj.id
        }
      };
    },
    getSelectConditionExpression() {
      let selectedId = this.$refs["select"].value;
      if (!selectedId) {
        return "()";
      }
      return "(" + this.config.code + "==" + selectedId + ")";
    },
    setSelectConditionValue(data) {
      this.$refs[this.config.type].value = data.value.id;
    },

    //number
    getNumberDocumentation() {
      return {
        numberData: this.$refs["number"].numberData
      };
    },
    getNumberConditionExpression() {
      let expression = "",
        number = this.$refs["number"].numberData;

      if (number.compareType === "among") {
        expression =
          "(" +
          number.leftRangeValue +
          number.leftRangeType +
          this.config.code +
          "&&" +
          this.config.code +
          number.rightRangeType +
          number.rightRangeValue +
          ")";
      } else {
        expression =
          "(" +
          this.config.code +
          number.compareType +
          number.compareValue +
          ")";
      }

      return expression;
    },
    setNumberConditionValue(data) {
      this.$refs[this.config.type].numberData = data.numberData;
    },

    // multiSelect
    getMultiSelectDocumentation() {
      return {
        operation: this.$refs["multiSelect"].connection,
        value: this.$refs["multiSelect"].multiSelectedIds.map(item => ({
          name: item,
          id: item
        }))
      };
    },
    getMultiSelectConditionExpression() {
      let multiSelectedIds = this.$refs["multiSelect"].multiSelectedIds;
      let connection = this.$refs["multiSelect"].connection;
      if (!multiSelectedIds.length) {
        return "()";
      }
      let expression = "";
      expression =
        "(" +
        multiSelectedIds
          .map(item => this.config.code + ".contains" + "(" + item + ")")
          .join("&&") +
        ")";
      if (connection === "subset") {
        return expression;
      }
      return (
        expression +
        "&&" +
        "(" +
        this.config.code +
        ".length==" +
        multiSelectedIds.length +
        ")"
      );
    },
    setMultiSelectConditionValue(data) {
      this.$refs[this.config.type].connection = data.operation;
      this.$refs[this.config.type].multiSelectedIds = data.value.map(
        item => item.id
      );
    },

    // department
    getDepartmentDocumentation() {
      return {
        selectedDepartments: this.$refs["department"].selectedDepartments.map(
          item => ({
            name: item.name,
            id: item.id
          })
        ),
        containChildDepartment: this.includeChildDepartments,
        conditionName: `${this.currentEditNode.id}${this.config.code}`
      };
    },

    getProjectDocumentation() {
      return {
        selectedProjects: this.$refs["project"].selectedProject.map(item => ({
          name: item.name,
          id: item.id
        })),
        containChildProject: this.includeChildProject,
        conditionName: `${this.currentEditNode.id}${this.config.code}`
      };
    },

    // costTypes
    getCostTypesDocumentation() {
      return this.$refs["chargeTypes"].documentation;
    },

    getCostTypesExpression() {
      return this.$refs.chargeTypes.conditionExpression;
    },

    setCostTypesForm(costTypes) {
      this.$refs.chargeTypes.chargeForm = costTypes.map(costItem =>
        costItem.selectedValue.map(item => item.id)
      );
    },

    getProjectExpression() {
      return `${this.currentEditNode.id}${this.config.code}.contains(projectId)`;
    },

    getDepartmentConditionExpression() {
      return `${this.currentEditNode.id}${this.config.code}.contains(departmentId)`;
    },
    setDepartmentConditionValue(data) {
      this.defaultVal = data.selectedDepartments.map(item => {
        return {
          name: item.name,
          id: item.id,
          type: 0
        };
      });

      this.includeChildDepartments = data.containChildDepartment || false;
    },

    setProjectForm(data) {
      this.defaultParject = data.selectedProjects.map(item => {
        return {
          name: item.name,
          id: item.id
        };
      });

      this.includeChildProject = data.containChildProject || false;
    },

    // employee
    getEmployeeDocumentation() {
      return {
        value: this.$refs["employee"].selectedEmployees.map(item => ({
          name: item.name,
          id: item.id
        }))
      };
    },
    getEmployeeConditionExpression() {
      return this.getEmployeeOrDepartmentConditionExpression(
        this.config.code,
        this.$refs["employee"].selectedEmployees
      );
    },
    setEmployeeConditionValue(data) {
      this.defaultVal = data.value.map(item => {
        return {
          name: item.name,
          id: item.id,
          type: 1
        };
      });
    },

    getConditionOperationConfig(type) {
      let operationConfig = {
        department: {
          getDocumentation: this.getDepartmentDocumentation,
          getConditionExpression: this.getDepartmentConditionExpression,
          setConditionValue: this.setDepartmentConditionValue,
        },

        employee: {
          getDocumentation: this.getEmployeeDocumentation,
          getConditionExpression: this.getEmployeeConditionExpression,
          setConditionValue: this.setEmployeeConditionValue
        },

        select: {
          getDocumentation: this.getSelectDocumentation,
          getConditionExpression: this.getSelectConditionExpression,
          setConditionValue: this.setSelectConditionValue
        },

        multiSelect: {
          getDocumentation: this.getMultiSelectDocumentation,
          getConditionExpression: this.getMultiSelectConditionExpression,
          setConditionValue: this.setMultiSelectConditionValue
        },

        number: {
          getDocumentation: this.getNumberDocumentation,
          getConditionExpression: this.getNumberConditionExpression,
          setConditionValue: this.setNumberConditionValue
        },

        costTypes: {
          getDocumentation: this.getCostTypesDocumentation,
          getConditionExpression: this.getCostTypesExpression,
          setConditionValue: this.setCostTypesForm
        },

        project: {
          getDocumentation: this.getProjectDocumentation,
          getConditionExpression: this.getProjectExpression,
          setConditionValue: this.setProjectForm
        }
      };
      return operationConfig[type];
    },

    getEmployeeOrDepartmentConditionExpression(conditionCode, data) {
      let expression = "";
      if (data.length) {
        expression =
          "(" +
          data.map(item => conditionCode + "==" + item.id).join("||") +
          ")";
      } else {
        expression = "()";
      }
      return expression;
    }
  }
};
</script>

<style scoped lang="scss">
@import "./common.scss";
.charge-item-project {
  // dis
}
</style>
